import { blue20opacity15, blue50 } from '../../../colors/blue';
import { gray40opacity10, gray80, white } from '../../../colors/gray';
import { green02opacity20, green03, green04 } from '../../../colors/green';
import { red02opacity20, red03, red04 } from '../../../colors/red';
import { yellow02, yellow02opacity30, yellow03, yellow04 } from '../../../colors/yellow';
import { rem } from '../../../utils/rem';
import { palette } from '../palette';
import { shape } from '../shape';
export var MuiAlert = {
    styleOverrides: {
        root: {
            borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
            paddingTop: rem('4px'),
            paddingBottom: rem('4px'),
            // alignItems: 'center',
            '& [class*=MuiSvgIcon-root]': {
                width: '1em',
                height: '1em',
            },
            '& .MuiAlertTitle-root': {
                marginTop: 0,
            },
        },
        icon: {
            padding: "".concat(rem(7), " 0 ").concat(rem(3), " 0"),
        },
        standard: {
            '& 	.MuiAlert-action': {
                color: palette.text.primary,
            },
        },
        message: {
            fontSize: rem(14),
            paddingTop: rem('5px'),
            paddingBottom: rem('3px'),
        },
        filledInfo: {
            backgroundColor: blue50,
            borderRadius: 0,
            color: white,
            fontWeight: 'normal',
        },
        filledSuccess: {
            backgroundColor: green04,
            borderRadius: 0,
            color: white,
            fontWeight: 'normal',
        },
        filledWarning: {
            backgroundColor: yellow02,
            borderRadius: 0,
            color: gray80,
            fontWeight: 'normal',
        },
        filledError: {
            backgroundColor: red03,
            borderRadius: 0,
            color: white,
            fontWeight: 'normal',
        },
        standardInfo: {
            backgroundColor: blue20opacity15,
            color: blue50,
        },
        standardSuccess: {
            backgroundColor: green02opacity20,
            color: green04,
            '& .MuiAlert-icon': {
                color: green03,
            },
        },
        standardWarning: {
            backgroundColor: yellow02opacity30,
            color: yellow04,
            '& .MuiAlert-icon': {
                color: yellow03,
            },
        },
        standardError: {
            backgroundColor: red02opacity20,
            color: red04,
        },
        action: {
            padding: 0,
            paddingBlockStart: rem(1),
            paddingInlineStart: rem(16),
            '& [class*=MuiButton-root]': {
                fontWeight: 600,
            },
        },
    },
    customOverrides: {
        general: {
            backgroundColor: gray40opacity10,
            color: gray80,
        },
        small: {
            // maxHeight: 26,
            paddingTop: '0',
            paddingBottom: '0',
        },
    },
};
